import { render, staticRenderFns } from "./KnTrainingField.vue?vue&type=template&id=a53b2ab8"
import script from "./KnTrainingField.js?vue&type=script&lang=js&external"
export * from "./KnTrainingField.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports